import $ from "jquery";

(function () {
  $(document).click(function(event) {
    const menu = $('.menu');
    const burger = $('.burger');

    if (burger.hasClass('open')) {
      if (!menu.is(event.target) && !burger.is(event.target) && menu.has(event.target).length === 0) {
        $('.nav-main').removeClass('active')
        burger.removeClass('open')
        $('.close-menu').removeClass('open')
      }
    } else {
      if (burger.is(event.target)) {
        $('.nav-main').addClass('active')
        burger.addClass('open')
        $('.close-menu').addClass('open')
      }
    }
  });

  $('.close-menu , .nav-main .after').click(function () {
    $('.nav-main').removeClass('active')
    $('.burger').removeClass('open')
    $('.close-menu').removeClass('open')
  })

  function stickyHeader() {
    if ($(window).scrollTop() > 0) {
      $('header').addClass('header-fixed');
    } else {
      $('header').removeClass('header-fixed');
    }
  }

  $(window).scroll(stickyHeader)
  $(document).ready(stickyHeader)

  $('.menu-item-has-children').each(function () {
    $(this).append( "<span class='chevron'></span>" );
  })

  $('.chevron').click(function () {
    $(this).parent().toggleClass('open')
  })
})()


